import { AbstractControl, ValidationErrors } from '@angular/forms';

export function maxLengthHtml(maxLength: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    // Strip HTML tags
    const plainText = control.value.replace(/<\/?[^>]+(>|$)/g, "");
    console.log(plainText)

    // Check the plain text length
    if (plainText.length > maxLength) {
      return { maxLengthHtml: { requiredLength: maxLength, actualLength: plainText.length } };
    }

    return null;
  };
}
